import { initChart, getCommonOptionDonut } from '../common';

export function echartIntensidadRealTimeCiclista(vis, datos) {
  const data = datos.resultset.map(([name, value]) => ({ name, value }));
  const options = getCommonOptionDonut(data, 'Major intensitat darrera hora');

  initChart('chartIntensidadRealTimeCiclista', options);
}
